import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ServicesService } from '../../business-services/services.service';


@Injectable({ providedIn: 'root' })
export class EditServiceGuard  {

  constructor(
    private service: ServicesService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.service.serviceId) {
      return true;
    }
    return this.router.createUrlTree(['/services']);
  }
}
